import React from 'react';
import { LayersIcon, GiftIcon, FileTextIcon, ActivityIcon, DumbbellIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
const chips = [{
  icon: LayersIcon,
  label: '6 Volumes'
}, {
  icon: GiftIcon,
  label: '5 Field Bonuses'
}, {
  icon: FileTextIcon,
  label: '300+ Pages'
}, {
  icon: ActivityIcon,
  label: '40+ Conditions'
}, {
  icon: DumbbellIcon,
  label: 'Mat + Reformer'
}];
export function Hero() {
  return <header className="w-full bg-paper" data-id="element-143" data-mp="xanpc0x21jfw">
      <div className="mx-auto grid max-w-content grid-cols-1 items-center gap-14 px-5 py-16 sm:px-8 sm:py-24 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 lg:py-28" data-id="element-144" data-mp="xbp9cuw1tg9r">
        <div data-id="element-145" data-mp="ncgiiawhchrm">
          <p className="inline-flex items-center gap-2 rounded-full bg-sage-soft px-4 py-2 font-sans text-[11px] font-semibold uppercase leading-none tracking-[0.14em] text-sage" data-id="element-146" data-mp="nczqozwbvrsg">
            <span aria-hidden="true" data-id="element-147" data-mp="382p55bt4dbkm">◆</span>
            Screen &amp; Adapt™ — The Pilates Instructor's Injury Decision System
          </p>

          <h1 className="mt-7 font-serif text-[34px] font-semibold leading-[1.12] tracking-[-0.01em] text-ink sm:text-5xl lg:text-[60px]" data-id="element-148" data-mp="3j9ty8ric7ai4">
            Your certification taught you the exercises. Nobody taught you what to do when a client
            says "I have a bad back."
          </h1>

          <p className="mt-6 max-w-[38rem] font-sans text-[17px] leading-[1.65] text-ink-soft sm:text-lg" data-id="element-149" data-mp="3e84nze2xv0v3">
            Screen &amp; Adapt™ gives you 90-second decision protocols for 40+ injuries and
            conditions — exactly what to ask, what to avoid, what to teach instead, and when to
            refer out. So you never freeze, never guess, and never step outside your scope.
          </p>

          <ul className="mt-8 flex flex-wrap gap-2" data-id="element-150" data-mp="2vjpzaxg3fyxg">
            {chips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-full border border-sage/15 bg-white px-3 py-1.5 font-sans text-[12px] font-medium text-ink-soft" data-id="element-151" data-mp="2hjowvdk6kjfv">
                <Icon className="h-3.5 w-3.5 text-sage" strokeWidth={1.75} aria-hidden="true" data-id="element-152" data-mp="s3urnyvqxcbo" />
                {label}
              </li>)}
          </ul>

          <div className="mt-10" data-id="element-153" data-mp="icromrj9an9r">
            <CtaButton href="#pricing" data-id="element-154" data-mp="i9vu7d6magq2">Get Screen &amp; Adapt™ — Instant Access</CtaButton>
            <TrustRow className="mt-4" data-id="element-155" data-mp="dbapp1kc1avt" />
          </div>
        </div>

        <div className="relative mx-auto w-full max-w-[520px]" data-id="element-156" data-mp="1b0drfxkntnvk">
          <img src="https://cdn.magicpatterns.com/uploads/uAGrsJnP93tMz5VnHEkcRB/hf_20260821_011907_28beeae1-2639-4952-b5ba-8eae32b91d88.png" alt="The six Screen &amp; Adapt volumes with the 90-Second Screen open on a phone" className="w-full rounded-2xl object-cover shadow-lift" loading="eager" data-id="element-157" data-mp="161b0fh1ili6l" />
        </div>
      </div>
    </header>;
}